

module.exports = __webpack_require__.stylable.create(
    "Events782233432",
    {"classes":{"root":"Events782233432__root","mobile-mixin":"Events782233432__mobile-mixin","Plus":"Events782233432__Plus","Bullet":"Events782233432__Bullet","EventsContainer":"Events782233432__EventsContainer","EventExtension":"Events782233432__EventExtension"},"vars":{},"stVars":{"BorderWidth":"'\"unit(fallback(--cellBorderWidth, 1), px)\"'","PlusMoreFontColor":"\"fallback(color(--currentFontColor), fallback(color(--runningTextColor), color(color-5)))\""},"keyframes":{}},
    "",
    20,
    "Events782233432",
    null
);
